import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

document.addEventListener("DOMContentLoaded", function () {
  const blocks = document.querySelectorAll(".team-slider");

  blocks.forEach((block) => {
    const slider = block.querySelector(".swiper");
    if (!slider) return;

    const prev = block.querySelector(".swiper-button-prev");
    const next = block.querySelector(".swiper-button-next");
    const paginationEl = block.querySelector(".swiper-pagination");

    new Swiper(slider, {
      slidesPerView: "auto",
      spaceBetween: 16,
      loop: false,
      allowTouchMove: true,
      speed: 600,
      navigation: {
        prevEl: prev,
        nextEl: next,
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      modules: [Navigation, Pagination],
    });
  });
});
